<div class="container">
  <img src="../../assets/img/iclinic.svg" />
  <div class="content">
    <h1>Manutenção programada</h1>
    <p>Pedimos desculpas por isso, mas não se preocupe.
      Nosso sistema estará indisponível na data 14/06/2023 a partir das 21:00 horas, para manutenção.
      Previsão 3 horas.</p>
  </div>
</div>